{
    "adDocDescriptionAtReportedTime": "Descriptif de l'annonce au moment du signalement:",
    "reportedForRaison": "Raison du signalement:",
    "noDocChangesReported": "Aucun changement dans le document"
}